import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalState } from "./modal.state";
import { ModalItem } from "./modal.types";

const initialState: ModalState = {
  modals: [],
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<ModalItem>) => {
      state.modals.push(action.payload);
    },
    destroy: (state) => {
      state.modals.pop();
    },
    destroyAll: (state) => {
      state.modals = [];
    },
    destroyByName: (state, action: PayloadAction<string>) => {
      state.modals = state.modals.filter((m) => m.name !== action.payload);
    },
  },
});

export const { append, destroy, destroyAll, destroyByName } = modalSlice.actions;
export default modalSlice.reducer;
